export default "__VITE_PUBLIC_ASSET__b7edbf8d__"